import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'assign_lists_to_all_in_department';

export const useAssignListsToAllInDepartmentTranslation = ():
UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    label: 'Назначать всем в подразделении',
    toast_error: 'Не удалось изменить назначение списков',
    toast_success: 'Изменения сохранены',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    label: 'Assign to everyone in department',
    toast_error: 'Failed to update list assignment',
    toast_success: 'Changes saved',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    label: 'Asignar a todos en el departamento',
    toast_error: 'Error al actualizar la asignación de listas',
    toast_success: 'Cambios guardados',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    label: 'Atribuir a todos no departamento',
    toast_error: 'Falha ao atualizar a atribuição de listas',
    toast_success: 'Alterações salvas',
  },
}) : {}) as Record<string, unknown>;
